export const THEME_STORAGE_KEY = 'dealer-commerce-theme'

export const theme = {
  colors: {
    background: '#000000',
    backgroundSoft: '#0a0a0f',
    primary: '#FF0033',
    foreground: '#FFFFFF',
    muted: '#a1a1aa',
    success: '#22c55e',
    warning: '#f59e0b',
    info: '#38bdf8',
    destructive: '#ff3344',
  },
  fonts: {
    sans: 'Outfit',
    display: 'Poppins',
  },
  radii: {
    md: '0.75rem',
    lg: '1rem',
    xl: '1.25rem',
  },
  shadows: {
    soft: '0 8px 32px rgba(0, 0, 0, 0.55)',
    glow: '0 0 24px rgba(255, 0, 51, 0.35)',
  },
  modes: ['dark', 'light'],
} as const

export type ThemeMode = (typeof theme.modes)[number]
